import InheritanceTransferApi, {
  InheritanceTransferFile,
} from "../../api/inheritance-transfer/inheritance-transfer.api";

/** ตัด timestamp ที่ backend เติมหน้าชื่อไฟล์ออก ('1725690000000-ใบมรณบัตร.pdf' -> 'ใบมรณบัตร.pdf') */
export const displayFileName = (fileName?: string) =>
  String(fileName || "").replace(/^\d{10,}-/, "") || "-";

/**
 * ดาวน์โหลดไฟล์แนบผ่าน API ที่มี token — เปิด URL ตรงไม่ได้เพราะ endpoint อยู่ใต้ JWT guard
 * โยน error ต่อให้ผู้เรียกจัดการข้อความ (404 ของ backend ตอบ body ว่าง จึงต้อง fallback ข้อความเอง)
 */
export const downloadInheritanceFile = async (file: InheritanceTransferFile) => {
  const res = await InheritanceTransferApi.downloadFile(file.download_url);

  const url = URL.createObjectURL(res.data);
  const link = document.createElement("a");
  link.href = url;
  // ใช้ชื่อจาก list ตรงๆ ไม่ต้อง parse Content-disposition ที่ผ่าน encodeURI มา
  link.download = displayFileName(file.file_name);
  // Firefox ต้องให้ element อยู่ใน DOM ก่อน click ไม่งั้นไม่เริ่มดาวน์โหลด
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // revoke ช้าหน่อย กันบาง browser ที่ยังอ่าน blob ไม่เสร็จตอน click คืนค่า
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

/**
 * เปิดดูไฟล์แนบในแท็บใหม่ (backend ส่ง Content-disposition: attachment แต่ blob ที่ front ถือทำอะไรก็ได้)
 *
 * ต้องรับ tab ที่ผู้เรียก `window.open('', '_blank')` ไว้แล้วตอน onClick — เปิดหลัง await
 * จะหลุด user gesture แล้วโดน popup blocker
 */
export const openInheritanceFile = async (
  file: InheritanceTransferFile,
  tab: Window | null
) => {
  const res = await InheritanceTransferApi.downloadFile(file.download_url);

  const url = URL.createObjectURL(res.data);
  if (tab) tab.location.href = url;
  // ให้เวลาแท็บโหลดไฟล์ให้เสร็จก่อน revoke — เร็วกว่านี้ PDF ขนาดใหญ่จะเปิดไม่ขึ้น
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};
